// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KiWgLW{display:flex;align-items:center;justify-content:space-between;padding:15px 0}.KiWgLW.CZRNp2{padding:0}.czpZLS{height:15px}.Eg1OfK svg{width:6px;height:9px}.AMXhP6 svg{width:13px;height:10px}.rX40Rw{display:flex;align-items:center;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;text-transform:uppercase;max-width:160px}.GqqEV1{background:#ea492e;width:7px;height:7px;border-radius:50%;margin-right:6px;order:0}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `KiWgLW`,
	"with-social-button": `CZRNp2`,
	"withSocialButton": `CZRNp2`,
	"icon": `czpZLS`,
	"icon-play": `Eg1OfK`,
	"iconPlay": `Eg1OfK`,
	"icon-arrow": `AMXhP6`,
	"iconArrow": `AMXhP6`,
	"label": `rX40Rw`,
	"circle": `GqqEV1`
};
export default ___CSS_LOADER_EXPORT___;
